document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lp-product').forEach(initProductSection);
});

function initProductSection(root) {
  // --- Gallery ---
  var images = root.querySelectorAll('.lp-gallery__image');
  var thumbs = root.querySelectorAll('.lp-gallery__thumb');
  var prevBtn = root.querySelector('.lp-gallery__nav--prev');
  var nextBtn = root.querySelector('.lp-gallery__nav--next');
  var current = 0;

  function showImage(index) {
    if (!images.length) return;
    current = (index + images.length) % images.length;
    images.forEach(function (img, i) {
      img.classList.toggle('is-active', i === current);
    });
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === current);
    });
    if (thumbs[current] && thumbs[current].scrollIntoView) {
      thumbs[current].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showImage(parseInt(thumb.dataset.index, 10));
    });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { showImage(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImage(current + 1); });

  // --- Thumbnail strip arrow scroll ---
  var thumbsTrack = root.querySelector('.lp-gallery__thumbs');
  var thumbsPrev = root.querySelector('.lp-thumbs-nav--prev');
  var thumbsNext = root.querySelector('.lp-thumbs-nav--next');
  function scrollThumbs(direction) {
    if (!thumbsTrack) return;
    var amount = thumbsTrack.clientWidth * 0.8 * direction;
    thumbsTrack.scrollBy({ left: amount, behavior: 'smooth' });
  }
  if (thumbsPrev) thumbsPrev.addEventListener('click', function () { scrollThumbs(-1); });
  if (thumbsNext) thumbsNext.addEventListener('click', function () { scrollThumbs(1); });

  // --- Variant selection (color swatches + any other option selects) ---
  var form = root.querySelector('.lp-form');
  if (form) {
    var variantsScript = form.querySelector('[data-product-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      variants = [];
    }

    var selected = [];
    try {
      selected = JSON.parse(form.dataset.selectedOptions || '[]');
    } catch (e) {
      selected = [];
    }

    var variantIdInput = form.querySelector('.lp-variant-id');
    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    var addToCartLabel = form.querySelector('[data-add-to-cart-label]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceBadge = root.querySelector('[data-price-badge]');

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceCurrent) priceCurrent.textContent = variant.price;
      if (variant.compare_at_price && variant.discount > 0) {
        if (priceCompare) { priceCompare.textContent = variant.compare_at_price; priceCompare.style.display = ''; }
        if (priceBadge) { priceBadge.textContent = variant.discount + '% Off'; priceBadge.style.display = ''; }
      } else {
        if (priceCompare) priceCompare.style.display = 'none';
        if (priceBadge) priceBadge.style.display = 'none';
      }

      if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      if (addToCartLabel) addToCartLabel.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    function updateOptionLabels() {
      root.querySelectorAll('[data-option-value-index]').forEach(function (el) {
        var idx = parseInt(el.dataset.optionValueIndex, 10);
        if (selected[idx] !== undefined) el.textContent = selected[idx];
      });
    }

    function selectOption(index, value) {
      selected[index] = value;
      updateOptionLabels();
      applyVariant(findVariant());
    }

    // Color swatches
    root.querySelectorAll('.lp-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('.lp-swatches');
        group.querySelectorAll('.lp-swatch').forEach(function (s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
        var index = parseInt(swatch.dataset.optionIndex, 10);
        selectOption(index, swatch.dataset.value);
      });
    });

    // Any other option selects (size, etc.)
    root.querySelectorAll('.lp-select').forEach(function (select) {
      select.addEventListener('change', function () {
        var index = parseInt(select.dataset.optionIndex, 10);
        selectOption(index, select.value);
      });
    });
  }
}